import React, { useEffect } from "react";
import { UserManager, WebStorageStateStore } from "oidc-client";

const MedicareSSORedirect = () => {

    useEffect(() => {
        let npn = JSON.parse(localStorage.getItem('roper')).npn
        const config = {
            authority: process.env.REACT_APP_MEDICARE_AUTH_AUTHORITY_URL,
            client_id: process.env.REACT_APP_IDENTITY_CLIENT_ID,
            redirect_uri: process.env.REACT_APP_MEDICARE_REDIRECT_URL,
            response_type: process.env.REACT_APP_MEDICARE_AUTH_RESPONSE_TYPE,
            scope: process.env.REACT_APP_MEDICARE_AUTH_SCOPE,
            userStore: new WebStorageStateStore({ store: window.localStorage }),
            popupWindowFeatures : null
        };
        const SSOmgr = new UserManager(config)
        SSOmgr.signinRedirect({
          extraQueryParams: {
              username: npn
          }
        });
    }, []);
   
    return (
        <div className="content-frame v2">
            Redirect
        </div>
    );
};

export default MedicareSSORedirect;